import actionTypes from '../constants/action-types';

const session = (state = null, action) => {
  if (action.type !== actionTypes.SET_SESSION) return state;

  return action.payload.site.session;
};

export default session;
